import Splide from '@splidejs/splide';
import '@splidejs/splide/css/core';
import './news.scss';

// import NewsSlider from './NewsSlider.svelte'

interface SFNewsItem {
  Id: string
  LastModified: string
  PublicationDate: string
  "Title": string
  "Description": string
  "DateCreated": string
  IncludeInSitemap: boolean
  SystemSourceKey: null|string
  UrlName: string|URL
  ItemDefaultUrl: string|URL
  Order: null|number
  AllowComments: boolean
  Summary: string
  Content: string
  Author: string
  SourceName: string
  SourceSite: string
  Provider: string
};

interface AEMNewsItem {
  Title: string;
  Link: string;
  Description: string;
  PubDate: Date;
  strPubDate: string;
  ID: number;
  Enclosure: string;
  NewsStories: number;
  ToggleImages: boolean;
  ContentTitle: string;
  TxtContent: string;
  IconClass: string;
};

const newsSliderDOM = document.getElementById('com-news-slider');
let newsSlider: Splide|undefined = undefined;
let splideSlideLength: number|undefined = undefined;
let mobile = false;
let newsSlides: NodeList|undefined = undefined;

// the breakpoints at which we will do things. We need these values in our custom slide number adjustments, so I hoisted them up here.
const BP = {
  singleSlide: {
    w: 480,
    maxCount: 4,
  },
  doubleSlide: {
    w: 991,
    maxCount: 12,
  },
};

const splideOptions = {
  type: 'loop',
  autoplay: true,
  gap: '1rem',
  perPage:3,
  perMove:3,
  pagination: true,
  breakpoints: {
    [BP.singleSlide.w]: {
      perPage:1,
      perMove:1,
    },
    [BP.doubleSlide.w]: {
      perPage:2,
      perMove:2,
    },
  },
};

let currentPageDOM;

const playPauseHandler = (e)=> {
  if(window.getComputedStyle(playDOM).display === 'none') {
    isPaused = false;
  } else {
    isPaused = true;
  }
}

/**
 * Runs one time, adds spans to use as timers.
 * @param e Event
 */
const paginationMountedHandler = (e)=> {
  const buttons = e.list.querySelectorAll('button');
  // You can add your class to the UL element
  // data.list.classList.add( 'uc-slider-pages' )

  buttons.forEach((_)=> {
    // _.textContent = String( _.page + 1 ) // aria-label takes care of this
    const span = document.createElement('span');
    span.className = 'progress-indicator';
    _.appendChild(span);
  });
};

const tickHandler = (e)=> {
  if(currentPageDOM) currentPageDOM.style.width = `${(e * 100).toFixed(0) || 0}%`;
};

const paginationUpdateHandler = (e)=> {
  currentPageDOM = e.list.querySelector('.is-active').firstChild;
};

let lastBpAdjustment: string|null = null;
let lastWidthAdjustedAt: number|null = null;

/**
 * Prunes slides for mobile.
 * Needs to be modified to add slides back in if traversing breakpoints upward (e.g. portait-to-landscape on tablet).
 * 
 * I got that started a bit here, but you'll need to refine what I started here (I'm not sure this setup is 100%) and figure out the best way
 * to add slides back in. That could be destroying and reinitializing, in which case I'd move the slider creation to its own function.
 * 
 * @returns void
 */
function adjustSlideCount() {
  let currentBP = null;
  // We'll want to do something like this, but should cache which BP we last operated on
  if(document.body.offsetWidth <= BP.singleSlide.w) {
    currentBP = 'singleSlide';
  } else if(document.body.offsetWidth <= BP.doubleSlide.w) {
    currentBP = 'doubleSlide';
  } else {
    currentBP = 'desktop';
    // desktop - if last BP adjustment was not desktop, reinitialize with all slides (newsSlides)
  }

  // nothing to do, return
  if(currentBP === lastBpAdjustment || !lastWidthAdjustedAt) return;
  

  // reinstate slides
  // might have to toy with whether it's best to bring them all back, then let pruning happen again, or more precisely add slides in
  if(newsSlides && !lastWidthAdjustedAt || (lastWidthAdjustedAt ?? document.body.offsetWidth) < document.body.offsetWidth) {
    console.log('reinstate slides')
    // @TODO reinstate all slides - https://splidejs.com/guides/apis/
    // https://splidejs.com/guides/apis/#add
    // or...?
    // https://splidejs.com/guides/apis/#destroy
    // return; // whether we need this here will depend on how we add slides back in
  }

  // for the next run - may have to toy with where we do this
  lastBpAdjustment = currentBP;
  lastWidthAdjustedAt = document.body.offsetWidth; // we want this for simple numeric comparison so we can do a quick check whether the screen got bigger or smaller (I haven't done this yet)

  // otherwise, prune slides
  if(document.body.offsetWidth <= BP.singleSlide.w && splideSlideLength) {
    newsSlider?.remove('.rm-for-xsmall');
  } else if(document.body.offsetWidth <= BP.doubleSlide.w && splideSlideLength) {;
    newsSlider?.remove('.rm-for-small');
  }
}

if(newsSliderDOM) {
  newsSlides = newsSliderDOM.querySelectorAll('li');

  newsSlider = new Splide(newsSliderDOM, splideOptions)
    .on('resize', adjustSlideCount)
    .on('pagination:mounted', paginationMountedHandler)
    .on('pagination:updated', paginationUpdateHandler)
    .on('autoplay:playing', tickHandler)
    .mount();
  
  splideSlideLength = newsSlider.length;

  // we have to call it once on init
  adjustSlideCount();

  // console.log('init', {
  //   newsSlides,
  //   newsSlider,
  //   newsSliderDOM,
  //   splideSlideLength,
  //   state: newsSlider.state,
  // });
};